import { IMoveHandler, MoveHandlerParams } from "./MoveHandler";

export class InkMoveHandler implements IMoveHandler {
  handleMove(params: MoveHandlerParams): void {
    // set the real octopus piece to be shadowed
    // isShadow side effect handler will handle the side effects
    params.piece.isShadowed = true;
    params.movementManager.regularMove(
      params.fromPosition,
      params.toPosition,
      params.piece
    );
  }
}
